import React from 'react';
import T from 'i18n-react';

import { BidAndOffersIcon, BuyItNowIcon, CalendarIcon } from '@motorway/motorway-storybook-cra';

import useAccountRouter from 'Components/Account/useAccountRouter';
import { WithAccountPermitsChecker } from 'Controllers/AccountPermitsChecker/AccountPermitsChecker.helpers';
import { AccountDateRange } from 'Types/account';
import proPropTypes from 'Utilities/proPropTypes';

import { ACCOUNT_CATEGORIES } from '../AccountPage.consts';
import AccountEmptyView from '../shared/AccountEmptyView/AccountEmptyView';

T.setTexts(require('Components/texts.json'));

const { BIDS, PURCHASES } = ACCOUNT_CATEGORIES;

const CategoryIcon = Object.freeze({
	[BIDS]: <BidAndOffersIcon />,
	[PURCHASES]: <BuyItNowIcon />,
});

const useEmptyView = (permits) => {
	const { category, dateRangeType, keyword, slug } = useAccountRouter();
	const isEmptyDueToDateRange = dateRangeType !== AccountDateRange.ALL && dateRangeType;
	const isEmptyDueToSearch = keyword?.length;
	const shouldShowNoSearchResults = isEmptyDueToSearch;

	const getEmptyStateProps = ({ ...props }) => ({
		icon: CategoryIcon[category],
		showButton: false,
		slug,
		translateTarget: 'search',
		...props,
	});

	if (shouldShowNoSearchResults) {
		return {
			...getEmptyStateProps({
				keywordQuery: keyword,
			}),
		};
	}

	if (isEmptyDueToDateRange) {
		return {
			...getEmptyStateProps({
				icon: <CalendarIcon />,
				translateTarget: 'dateRangeType',
			}),
		};
	}

	return {
		...getEmptyStateProps({
			buttonLabelTextKey: 'browseVehicles',
			notFoundTextKey: 'defaultText',
			showButton: !permits.isPurchaseCancelledPage(),
			translateTarget: `${category}.${slug}`,
		}),
	};
};

const AccountNoResults = ({ permits }) => {
	const emptyViewProps = useEmptyView(permits);

	return <AccountEmptyView {...emptyViewProps} />;
};

AccountNoResults.propTypes = {
	permits: proPropTypes.accountPermitsChecker.isRequired,
};

export default WithAccountPermitsChecker()(AccountNoResults);
